<template>
  <section class="page-dashbord-password mt-3">
    <app-loading :isFull="true" v-if="isLoading"/>
    <div class="container">
      <div class="row">
        <div class="col">
          <header class="text-right mb-4">
            <h1 class="font-20">تغییر گذر واژه</h1>
          </header>
        </div>
      </div>
      <m-password @submitPassword="updatePassword"/>
    </div>
  </section>
</template>

<script>
import MPassword from 'cp/dashboard-component/password'
export default {
  name: 'page-dashbord-password',
  components: {
    MPassword
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    async updatePassword(formPassword) {
      try {
        this.isLoading = true
        let { data } = await axios.post('/users/update-password', formPassword)
        this.isLoading = false
        if (data.state != 200) {
          if (data.state == 400) {
            this.$store.commit('notifications/error', { message: 'گذرواژه  فعلی صحیح نمیباشد', title: '' })
          }
          return
        }
        this.$store.commit('notifications/success', { message: this.$t('message.request.done'), title: '' })
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>

<style lang="less">
@import (reference) "../../assets/css/variable.less";
.page-dashbord-password {
  .box-clear;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/password.vue